import React, { useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { BASE_URL } from "../../config";
import BatchResultModal from "./BatchResultModal";
import ScanLoaConfirmationModal from "./ScanLoaConfirmationModal";
import ScanLoaDocumentQrModal from "./ScanLoaDocumentQrModal";

const ScanLoaDocumentQrFullPage = () => {
  const [searchParams] = useSearchParams();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmData, setConfirmData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showBatchResultModal, setShowBatchResultModal] = useState(false);
  const [batchResult, setBatchResult] = useState(null);
  const [showScanPage, setShowScanPage] = useState(true);

  const [initialData] = useState(() => {
    const stateKey = searchParams.get("state_key");
    if (!stateKey) return null;

    try {
      const raw = sessionStorage.getItem(stateKey);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  });

  const handleProceedToConfirm = (data) => {
    setConfirmData(data);
    setShowConfirmModal(true);
  };

  const handleConfirmSubmit = async () => {
    if (!confirmData) return;

    const payload = {
      loa_rows: (confirmData.loaRows || []).map((row) => ({
        loa_no: row.loaNo,
        rtp_tag: row.rtpTag ? 1 : 0,
        rtp_code: row.rtpCode || "",
        rtp_remarks: row.rtpRemarks || "",
      })),
      rec_date: confirmData.dateReceived,
      provider_code: confirmData.providerCode,
      due_date: confirmData.dueDate,
      soa: confirmData.soaRef,
      soa_amount: Number(confirmData.soaAmount) || 0,
      act_claim_count: Number(confirmData.actualClaimCount) || 0,
      remarks: confirmData.remarks || "",
      accepted_by: confirmData.receivedBy || "",
    };

    setIsSubmitting(true);
    try {
      const token = localStorage.getItem("authentication/token");
      const response = await axios.post(
        `${BASE_URL}/claims/scan-loa/received-qr-batch`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const resultData = response.data?.data ?? {};
      if (response.data?.success) {
        setBatchResult({
          success: true,
          batchNo: resultData.batch_no,
          loaRows: confirmData.loaRows || [],
          message:
            response.data?.message ||
            "New batch has been successfully created and all LOA are attached.",
        });
        setShowConfirmModal(false);
        setShowScanPage(false);
        setConfirmData(null);
      } else {
        setBatchResult({
          success: false,
          failed: resultData.failed || [],
          message: response.data?.message || "Failed to create batch.",
        });
        setShowConfirmModal(false);
      }
      setShowBatchResultModal(true);
    } catch (err) {
      setBatchResult({
        success: false,
        failed: err.response?.data?.data?.failed || [],
        message:
          err.response?.data?.message ||
          "Unable to submit batch. Please try again.",
      });
      setShowConfirmModal(false);
      setShowBatchResultModal(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100">
      <ScanLoaDocumentQrModal
        isOpen={showScanPage}
        onClose={() => window.close()}
        onProceed={handleProceedToConfirm}
        initialData={initialData}
        variant="fullpage"
      />

      <ScanLoaConfirmationModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={handleConfirmSubmit}
        data={confirmData}
        loading={isSubmitting}
      />

      <BatchResultModal
        isOpen={showBatchResultModal}
        onClose={() => setShowBatchResultModal(false)}
        result={batchResult}
      />
    </div>
  );
};

export default ScanLoaDocumentQrFullPage;
